__turbopack_context__.v({
  "messageText": "PurchaseTokensMessage-module__5RMaKa__messageText",
  "purchaseButton": "PurchaseTokensMessage-module__5RMaKa__purchaseButton",
});
